module.exports = __webpack_public_path__ + "img/gameTronos2.26c7e756.jpg";